import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PublicRoutingModule } from './public-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { UserloginComponent } from './userlogin/userlogin.component';
import { UserRegistrationComponent } from './userRegistration/userRegistration.component';
import { FullscreenTimerComponent } from './fullscreen-timer/fullscreen-timer.component';
import { GoogleSigninButtonModule } from '@abacritt/angularx-social-login';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { VerifyOtpComponent } from './verify-otp/verify-otp.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ThanksComponent } from './thanks/thanks.component';
import { InstantTimerComponent } from './instant-timer/instant-timer.component';

@NgModule({
  declarations: [UserloginComponent,UserRegistrationComponent,FullscreenTimerComponent,ForgotPasswordComponent,VerifyOtpComponent,ResetPasswordComponent,ThanksComponent,InstantTimerComponent],
  imports: [
    CommonModule,
    RouterModule,
    PublicRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    MatGridListModule,
    MatDialogModule,
    MatButtonModule,
    MatMenuModule,
    MatExpansionModule,
    MatProgressSpinnerModule,
    GoogleSigninButtonModule,
  ]
})
export class PublicModule { }
